import { ToHopService } from "../services/tohop.service";
const monhoc = {
	tenMonHoc: "",
	diem1: 0,
	diem2: 0,
	diem3: 0,
	diemM: 0
};
var state = {
	tohops: [],
	monhoc: { ...monhoc },
	isLoadDiem: false,
	mons: [],
	diems: [],
	isLoadDelete: true, // khi load lại dữ liệu thì luôn là true để ko cập nhật số lần xuất hiện môn học, khi nào click thay đổi mới cho update
};

var getters = {};

var mutations = {
	getToHops(state, data) {
		state.tohops = data;
	},

	async xoaMonHoc(state, data) {
		if (data.tenToHop) {
			let monhocs = data.tenToHop.split(" - ");
			await monhocs.forEach((item) => {
				let index = state.mons.indexOf(item);
				if (index > -1) {
					if (state.diems[index].solan < 2) {
						state.mons.splice(index, 1);
						state.diems.splice(index, 1);
					} else {
						state.diems[index].solan -= 1;
					}
				}
			});
		}
	},

	updateIsLoadDelete(state, data) {
		state.isLoadDelete = data;
	},

	async themMonHoc(state, data) {
    if(data.tenToHop) {
      let monhocs = data.tenToHop.split(" - ");
      await monhocs.forEach((item, vt) => {
        let index = state.mons.indexOf(item);
        if (index > -1) {
          if (state.isLoadDiem === false) state.diems[index].solan += 1;
          if (state.isLoadDelete === false) {
            state.diems[index].solan += 1;
          }
        } else {
          state.mons.push(item);
          let diem = {
            tenMonHoc: item,
            diem1: data[`diem${vt + 1}1`] ? data[`diem${vt + 1}1`] : 0,
            diem2: data[`diem${vt + 1}2`] ? data[`diem${vt + 1}2`] : 0,
            diem3: data[`diem${vt + 1}3`] ? data[`diem${vt + 1}3`] : 0,
            diemM: data[`diemM${vt + 1}`] ? data[`diemM${vt + 1}`] : 0,
            solan: 1,
          };
          state.diems.push(diem);
        }
      });
    }
		
	},

	suaDiem(state, { diem, index }) {
		state.diems[index].diem = diem;
	},

	loadNew(state) {
		state.tohops = [];
		state.mons = [];
		state.diems = [];
	},
};

var actions = {
	getTopHopsByNganhId({ commit }, id) {
		return ToHopService.getTopHopsByNganhId(id)
			.then((response) => {
				if (response.status === 200) commit("getToHops", response.data);
				return response.data;
			})
			.catch((error) => error.message);
	},

	getToHops({ commit }) {
		return ToHopService.getToHops()
			.then((response) => {
				if (response.status === 200) commit("getToHops", response.data);
				return response.data;
			})
			.catch((error) => error.message);
	},

	xoaMonHoc({ commit }, id) {
		return ToHopService.getToHop(id)
			.then((response) => {
				if (response.status === 200) commit("xoaMonHoc", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

	themMonHoc({ commit }, id) {
		return ToHopService.getToHop(id)
			.then((response) => {
				if (response.status === 200) commit("themMonHoc", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

	suaDiem({ commit }, { diem, index }) {
		return commit("suaDiem", { diem, index });
	},

	async getDiemVaToHop({ rootState, state, commit }) {
		let nguyenvongs = await [
			...rootState.nguyenvong.nguyenvongs.sort((a, b) => a.thuTu - b.thuTu),
		];
		state.isLoadDiem = false;
		for (let item of nguyenvongs) {
			await ToHopService.getToHopById(item.toHopId).then((response) => {
				let data = {
					tenToHop: response.data.tenToHop,
					diem11: item.diem11,
					diem12: item.diem12,
					diem13: item.diem13,
					diem21: item.diem21,
					diem22: item.diem22,
					diem23: item.diem23,
					diem31: item.diem31,
					diem32: item.diem32,
					diem33: item.diem33,
					diemM1: item.diem1,
					diemM2: item.diem2,
					diemM3: item.diem3,
				};
				commit("themMonHoc", data);
			});
		}
		state.isLoadDiem = true;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
